export default function TrustBar() {
  return null;
}
